import React from "react"
import propTypes from "prop-types"

const Subtitle = ({ children }) => {
  return <div className="info-card_subtitle">{children}</div>
}

Subtitle.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired
}

export default Subtitle
